import _ from 'lodash';

export const CREATE_MODE = "create";
export const MODIFY_MODE = "modify";
export const DELETE_MODE = "delete";

export const getNewPluginConfig = (oldPlugins = [], newFields, pluginUid, mode) => {
    const newPlugins = _.cloneDeep(oldPlugins || []);
    switch (mode) {
        case CREATE_MODE:
            newFields.PluginUid = newFields.PluginUid.toUpperCase();
            return preparePluginsForSubmit([...newPlugins, newFields]);
        case MODIFY_MODE:
            const pluginIdxToModify = newPlugins.findIndex(item => item.PluginUid === pluginUid);
            if (pluginIdxToModify === -1) {
                return newPlugins;
            }
            if (newFields.PluginUid) {
                delete newFields.PluginUid;
            }
            newPlugins[pluginIdxToModify] = {...newPlugins[pluginIdxToModify], ...newFields};
            return preparePluginsForSubmit(newPlugins);
        case DELETE_MODE:
            const pluginIdxToDelete = newPlugins.findIndex(item => item.PluginUid === pluginUid);
            if (pluginIdxToDelete === -1) {
                return newPlugins;
            }
            delete newPlugins[pluginIdxToDelete];
            // Avoid sending null objects
            return preparePluginsForSubmit(newPlugins.filter(p => p));
        default:
            return preparePluginsForSubmit(newPlugins);
    }
}

export const preparePluginsForNodeConfig = plugins => {
    if (!plugins) {
        return [];
    }
    return plugins.map(p => ({...p, InputExtensions: p.InputExtensions.join(";")}))
}

export const preparePluginsForSubmit = plugins => {
    if (!plugins) {
        return [];
    }
    return plugins.map(p => {
        return {
            ...p,
            InputExtensions: checkExtensionsString(p.InputExtensions).split(";").sort((a,b) => a.localeCompare(b))
        }
    })
}

export const checkExtensionsString = input => {
    let newInput =  (input || "").trim().replaceAll(",", ";");
    if (newInput.length > 0 && newInput[newInput.length - 1] === ";") {
        newInput = newInput.slice(0, -1)
    }
    return newInput;
}